// extracted by mini-css-extract-plugin
export default {"cls1":"PingAnswerStyles-cls1__afe1b1070f79c3dd844d","cls2":"PingAnswerStyles-cls2__fccde3c697fb9c2b9910 PingAnswerStyles-cls1__afe1b1070f79c3dd844d"};